<template>
  <div>
    <v-layout row justify-center>
      <v-dialog v-model="addWarehouseDateModal" persistent max-width="400px">
        <v-card>
          <form action="" @submit.prevent="submitForm()">
            <v-card-title>
              <v-flex xs11 sm11 md11><span class="headline">Add Warehouse Date</span></v-flex>
              <v-flex xs1 sm1 md1>
                <v-btn flat @click="closeWarehouseDateModal(), $validator.reset()" class="close"
                  >&times;</v-btn
                >
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md4>
                    <date-picker
                      style="margin-top: 4%; border-bottom-color: #919191; width: 90%"
                      :date="startTime2"
                      :option="option2"
                      class="form-control"
                    ></date-picker>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                id="sendButton"
                type="submit"
                style="height: auto; margin-right: 7%"
                outline
                color="success"
                >Save</v-btn
              >
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import myDatepicker from 'vue-datepicker'

export default {
  props: [
    'closeWarehouseDateModal',
    'addWarehouseDateModal',
    'warehouseDateData',
    'submitWarehouseDate'
  ],

  components: {
    'date-picker': myDatepicker
  },

  data() {
    return {
      startTime2: {
        time: ''
      },
      option2: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        format: 'YYYY-MM-DD',
        placeholder: 'Warehouse Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      }
    }
  },

  watch: {
    addWarehouseDateModal: {
      immediate: false,
      handler() {
        if (this.addWarehouseDateModal) {
          this.startTime2.time = this.warehouseDateData.warehouse_date
        }
      }
    }
  },

  methods: {
    submitForm() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.warehouseDateData.warehouse_date = this.startTime2.time
          this.submitWarehouseDate()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/addWarehouseDate.vue